export default {
  disableTutorial: false,
  scriptsComplete: {}
}
